import { inject, injectable } from "inversify";
import AbstractConnect from "../../../../framework/src/connect/ajax/AbstractConnect";
import { parseURL } from "../../../../framework/src/connect/Connect";
import IConnectControl from "../../../../framework/src/connect/controllers/IConnectControl";
import FetchAjax from "../../../../framework/src/connect/FetchAjax";
import SERVICE_IDENTIFIER from "../../../../framework/src/constants/identifiers";
import SystemConfig, {
	CONFIG_PARAMS,
} from "../../../../framework/src/system/SystemConfig";
import IDOM from "../../../../framework/src/ui/IDOM";
import { IJackpotWin } from "../interfaces/IJackpotWin";

@injectable()
export class JokerBonusWinNotifier extends AbstractConnect {
	fetchType: string = "JokerWinConnect";
	jackpotId: string | number;
	roundId: number;
	ticketId: number;
	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
		@inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
		@inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
	) {
		super(config, control, fetch, dom);
		this.timeout = 3000;
		this.setMethod(this.config.get(CONFIG_PARAMS.URL_JOKER_BONUS_WIN_Method));
	}
	async fetch(): Promise<IJackpotWin> {
		this.control.reset();

		return (await this._fetch()).data;
	}
	protected getParams(): Record<string, any> {
		return { round_id: this.roundId };
	}
	protected getUrl(): string {
		return parseURL(this.config.get(CONFIG_PARAMS.URL_JOKER_BONUS_WIN), {
			casino_id: this.config.get(CONFIG_PARAMS.CASINO_ID),
			session_id: this.config.get(CONFIG_PARAMS.SESSION_ID),
			jackpot_id: this.jackpotId,
			ticket_id: this.ticketId,
			server_api: this.config.get(CONFIG_PARAMS.SERVER_API),
		});
	}
}
